<!-- Page content Start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="row g-5 align-items-center">
    <div class="col-lg-12 wow fadeInUp" data-wow-delay="0.1s">
      <h1 class="mb-4">
        {{ BAC_LIBRARY.title[this.language] }}
      </h1>
      <img
        width="700"
        src="../../../../../../assets/img/{{ BAC_LIBRARY.image }}"
        alt=""
        [style]="getLibraryStyleImage()"
      />
      <p [innerHtml]="BAC_LIBRARY.description[this.language]"></p>
    </div>
  </div>

  <app-articles-view
    [articles]="libraryArticles"
    [itemsPerPage]="limit"
    [totalcount]="totalcount"
    (onPaginateEvent)="onPaginateEvent($event)"
  ></app-articles-view>
</div>
<!-- Page content End-->
